import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Menu } from './models/Menu';
import { Locale } from './models/Locale';
import { Reservation } from './models/Reservation';
import {Department} from './models/Department';
import {Coupon} from './models/Coupon';
import {TimeSlot} from './models/TimeSlot';
import {TimeSlotResponse} from './models/TimeSlotResponse';
import { PaymentInfoResponse } from './models/PaymentInfoResponse';

@Injectable()
export class MainService {
    constructor(private _http: HttpClient) {}

    getLocale(localeCode, userLanguage): Observable<Locale> {
        const data = { cn: localeCode, pref_lang_code: userLanguage };
        const URL = environment.apiEndpoint + 'windex';
        return this._http.get<Locale>(URL, { params: data });
    }

    getMenu(token): Observable<Menu> {
        const data = { token: token };
        const URL = environment.apiEndpoint + 'getfullmenu';
        return this._http.get<Menu>(URL, { params: data });
    }

    sendReservation (reservation): Observable<any> {
        const URL = environment.apiEndpoint + 'makereservation';
        return this._http.post(URL, this.formatReservationPayload(reservation));
    }

    getDepartment (departmentId, amount): Observable<Department> {
        const data = { departmentId: departmentId, amount: amount };
        const URL = environment.apiEndpoint + 'getdepartment';
        return this._http.get<Department>(URL, { params: data });
    }

    getTimeSlots (departmentId, date, people, hallId = null, duration = null): Observable<TimeSlotResponse> {
      const data = {
        departmentId: departmentId,
        date: date,
        people: people,
        hallId: hallId,
        duration: duration
      };
      const URL = environment.apiEndpoint + 'reservation-time-slots';
      return this._http.get<TimeSlotResponse>(URL, { params: data });
    }

    getPaymentInfo (departmentId, date, peopleCount, reservationId = null, time = null, hallId = null): Observable<PaymentInfoResponse> {
      const data: any = {
        departmentId: departmentId,
        date: date,
        peopleCount: peopleCount,
        reservationId: reservationId
      };
      if (time) {
        data.time = time;
      }
      if (hallId) {
        data.hallId = hallId;
      }
      const URL = environment.apiEndpoint + 'reservation-payment-value';
      return this._http.get<PaymentInfoResponse>(URL, { params: data });
    }

    sendOrder (order): Observable<any> {
      const URL = environment.apiEndpoint + 'oplace';
      return this._http.post(URL, order);
    }
    getOrderDatesAvailable (departmentId, date = null): Observable<any> {
      let data = {};
      if (date) {
        data = {
          departmentId: departmentId,
          date: date
        };
      } else {
        data = {departmentId: departmentId}
      }
      const URL = environment.apiEndpoint + 'orderdatetimes';
      return this._http.get<any>(URL, { params: data });
    }

    getCoupon (localeId, couponName): Observable<Coupon> {
      const data = { localeId: localeId, couponName: couponName };
      const URL = environment.apiEndpoint + 'getcouponebyname';
      return this._http.get<Coupon>(URL, { params: data });
    }

    getReservationStatus (reservationCode): Observable<Coupon> {
      const data = { code: reservationCode };
      const URL = environment.apiEndpoint + 'get-reservation-status';
      return this._http.get<any>(URL, { params: data });
    }

  getReservation (reservation_id): Observable<Coupon> {
    const data = { id: reservation_id };
    const URL = environment.apiEndpoint + 'get-reservation-by-id';
    return this._http.get<any>(URL, { params: data });
  }

  sendGetReservationPaymentLink (reservation): Observable<any> {
    const URL = environment.apiEndpoint + '/widget/get-reservation-payment-link?reservation_id=' + reservation.id;
    return this._http.post(URL, this.formatReservationPayload(reservation));
  }

  getReservationByToken (token): Observable<any> {
    const URL = environment.apiEndpoint + 'booking/public/reservation-details/' + token;
    return this._http.get<any>(URL);
  }

  cancelReservation (token): Observable<any> {
    const URL = environment.apiEndpoint + 'booking/public/cancel-reservation/' + token;
    return this._http.post<any>(URL, {});
  }

  requestCancellation (token): Observable<any> {
    const URL = environment.apiEndpoint + 'booking/public/request-cancellation/' + token;
    return this._http.post<any>(URL, {});
  }

  private formatReservationPayload(reservation) {
    const d = reservation.reservationData;
    return {
      ...reservation,
      reservationData: d instanceof Date
        ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}T00:00:00`
        : d
    };
  }

}


